import propTypes from 'prop-types';
import classNames from 'classnames';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function Resizer(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    className: className,
    children: [/*#__PURE__*/jsx("line", {
      x1: "0.5",
      y1: "-0.5",
      x2: "11.5",
      y2: "-0.5",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0.5 9)"
    }), /*#__PURE__*/jsx("line", {
      x1: "0.5",
      y1: "-0.5",
      x2: "7.5",
      y2: "-0.5",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 4.74219 10.4142)"
    })]
  });
}

Resizer.propTypes = {
  className: propTypes.string.isRequired
};

var themes = ['light', 'dark'];

var _excluded = ["id", "placeholder", "className", "rows", "disabled", "theme"];
var classNamePrefix = 'forno-textarea';
function Textarea(_ref) {
  var id = _ref.id,
      placeholder = _ref.placeholder,
      className = _ref.className,
      rows = _ref.rows,
      disabled = _ref.disabled,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, _excluded);

  var customClassName = classNames(classNamePrefix, className);
  return /*#__PURE__*/jsxs("div", {
    "data-testid": "Textarea",
    className: customClassName,
    "data-disabled": disabled,
    "data-theme": theme,
    id: id,
    children: [/*#__PURE__*/jsx("textarea", _objectSpread2({
      className: "".concat(classNamePrefix, "-input"),
      placeholder: placeholder,
      rows: "".concat(rows),
      disabled: disabled
    }, rest)), /*#__PURE__*/jsx(Resizer, {
      className: "".concat(classNamePrefix, "-resizer")
    })]
  });
}
Textarea.propTypes = {
  id: propTypes.string,
  placeholder: propTypes.string,
  className: propTypes.string,
  rows: propTypes.string,
  disabled: propTypes.bool,
  theme: propTypes.oneOf(themes)
};
Textarea.defaultProps = {
  id: 'textarea',
  placeholder: 'Textarea',
  className: null,
  rows: '5',
  disabled: false,
  theme: 'light'
};

export { Textarea as default };
